import { Button, message, Tag } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import { getMoreData } from "../../common";
import DynamicTable from "../../components/DynamicTable";
import * as XLSX from "xlsx";
import download from "downloadjs";
import DateRangeSelect from "../../components/DateRangeSelect";

const DEFAULT_COLUMNS = {
  user: {
    show: true,
    label: "User",
    key: "user",
  },
  type: {
    show: true,
    label: "Type",
    key: "type",
  },
  amount: {
    show: true,
    label: "Amount",
    key: "amount",
  },
  note: {
    show: true,
    label: "Note",
    key: "note",
  },
  created_at: {
    show: true,
    label: "Date",
    key: "created_at",
  },
};

function Transactions() {
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(1);
  const [filteredTxs, setFilteredTxs] = useState([]);
  const [selectedRange, setSelectedRange] = useState([
    moment().subtract(30, "days"),
    moment(),
  ]);

  useEffect(() => {
    fetchTransactions(selectedRange);
  }, [selectedRange]);

  const fetchTransactions = async (dates) => {
    let startDate = dates[0];
    let endDate = dates[1];
    const res = await apiRequest({
      path: apiPaths.transactions+`?start_date=${startDate}&end_date=${endDate}`,
    });
    if (!res.error) {
      if (res.next) {
        return new Promise((resolve, reject) => {
          getMoreData({
            path: res.next,
            data: res.results,
            onFinish: (data) => {
              setTransactions(data);
              setFilteredTxs(data);
              resolve({ results: data });
            },
          });
        });
      } else {
        setTransactions(res.results);
        setFilteredTxs(res.results);
      }
    } else {
      message.error(res.error_description);
    }
  };

  const getColor = (type) => {
    switch (type) {
      case "credit":
        return "orange";
      case "refund":
        return "red";
      case "upi-ride":
        return "purple";
      case "cash-ride":
        return "yellow";
      default:
        return "green";
    }
  };

  const COLUMNS = [
    {
      title: "User",
      dataIndex: "user.username",
      fixed: "left",
      width: 100,
      filterType: "search",
      render: (_, record) => {
        return (
          <div>
            <div>{record.user?.fullname}</div>
            <div style={{ color: "#a7a7a7", fontSize: 11 }}>
              {record.user?.username}
            </div>
          </div>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      width: 60,
      filters: [
        {
          text: "Wallet Ride",
          value: "ride",
        },
        {
          text: "UPI Ride",
          value: "upi-ride",
        },
        {
          text: "Cash Ride",
          value: "cash-ride",
        },
        {
          text: "Credit",
          value: "credit",
        },
      ],
      onFilter: (value, record) => value == record.type,
      render: (value) => <Tag color={getColor(value)}>{value}</Tag>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 70,
    },
    {
      title: "Note",
      dataIndex: "note",
      filterType: "search",
      width: "200px",
    },
    {
      title: "Date",
      dataIndex: "created_at",
      filterType: "date",
      width: "100px",
      render: (_, record) => {
        return moment(record.created_at).format("DD-MM-YYYY HH:mm");
      },
    },
  ];

  const exportXlsx = () => {
    let exportUsers = filteredTxs.reduce((acc, curr) => {
      let { created_by, ride, user, _id, ...rest } = curr;
      let userDetails = {
        user: user?.username,
        ...rest,
      };
      acc.push(userDetails);
      return acc;
    }, []);
    let workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.json_to_sheet(exportUsers);
    var range = XLSX.utils.decode_range(worksheet["!ref"]);
    worksheet["!cols"] = [...Array(range.e.c)].map(() => ({ wch: 20 }));
    XLSX.utils.book_append_sheet(workbook, worksheet, "sheet_1");
    let data = XLSX.write(workbook, { type: "array" });
    download(
      data,
      "transactions.xlsx",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"
    );
  };

  const handleDelete = async (row) => {
    const res = await apiRequest({
      path: apiPaths.transactions + `/${row._id}`,
      method: "DELETE",
    });
    if (!res.error) {
      let updatedTrsx = transactions.filter((trx) => trx._id != row._id);
      setTransactions(updatedTrsx);
    }
  };

  return (
    <div style={{ height: "80vh" }}>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <DateRangeSelect
            selectedRange={selectedRange}
            onSelectedRangeChanged={setSelectedRange}
        />
        <Button type="primary" onClick={exportXlsx}>
          Export
        </Button>
      </div>
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={transactions}
          columns={COLUMNS}
          defaultColumns={DEFAULT_COLUMNS}
          // deleteBtn
          onRowDelete={handleDelete}
          showAction={() => false}
          pagination={{
            onChange(current) {
              setPage(current);
            },
          }}
        />
      </div>
    </div>
  );
}

export default Transactions;
